import React, { useEffect, useState } from 'react';
import { useCore } from './core';
import { useSession } from './session';

const NotificationsContext = React.createContext(null);

const VAPID_PUBLIC_KEY = 'BD8cmX+DSXapJSqtj5aJgx+eqKp/lw5UKy/Z/nFbVo69sfFxGHSxY6tWTyn8VfgzYzyDd09Jnl05QwhD2AfslVA=';

function NotificationsProvider({children}) {
    const { tenant, sessionLoading } = useSession();
    const { runNoAuthAction } = useCore();
    const [permission, setPermission] = useState('');
    const [subscriberId, setSubscriberId] = useState('');

    useEffect(() => {
        if (!sessionLoading) {
            requestNotificationPermission();
        }
    }, [sessionLoading])

    // Request notification permission
    const requestNotificationPermission = async() => {
        setPermission(await Notification.requestPermission());
    }

    useEffect(() => {
        if (permission === 'granted') {
            console.log('Notification permission granted.');
            subscribeUserToPush();
        } else {
            console.error('Notification permission denied.');
        }
    }, [permission])

    const subscribeUserToPush = async() => {
        try {
            // Ensure the service worker is ready
            const registration = await navigator.serviceWorker.ready;

            // Subscribe the user to push notifications
            const key = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
            
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true, // Ensures notifications are always visible
                applicationServerKey: key,
            });

            const keys = {
                p256dh: arrayBufferToBase64(subscription.getKey('p256dh')), 
                auth: arrayBufferToBase64(subscription.getKey('auth'))
            };
            await runNoAuthAction('webpush_subscribe', {tenantId: tenant.id, endpoint: subscription.endpoint, keys}, response => {
                console.log(`subscriberId: ${response.subscriberId}`);
                setSubscriberId(response.subscriberId);
            });

            console.log('Subscription details sent to the backend.');
        } catch (error) {
            console.error('Failed to subscribe the user to push notifications:', error);
        }
    }

    // Helper function to convert VAPID public key to Uint8Array
    const urlBase64ToUint8Array = (base64String) => {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    const arrayBufferToBase64 = (buffer) => {
        return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
    };

    const provider = {
        requestNotificationPermission,
        permission,
        subscriberId,
    }

    return <NotificationsContext.Provider value={provider}>{children}</NotificationsContext.Provider>
}

function useNotifications() {
    const context = React.useContext(NotificationsContext);
    if (!context) {
        throw new Error('useNotificaitons must be used within a NotificationsProvider');
    }
    return context;
}

export { NotificationsProvider, useNotifications }